import type { CSSProperties } from "react";

import { useTheme } from "@/lib/theme";
import darkLogo from "@/assets/logo_new.png";
import lightLogo from "@/assets/light-logo.png";

/**
 * Brand wordmark that follows the active theme: the gold-pin "light" logo on the
 * Light·Gold theme, and the existing logo on Dark·Gold. Pass sizing/utility
 * classes via `className` (e.g. "h-10 w-auto"). Swapping the theme re-renders it
 * automatically (see lib/theme.ts), so no per-page logic is needed.
 *
 * Surfaces pinned to one look regardless of the global theme (e.g. the
 * data-theme="dark" auth pages) must pass `variant` to match — the global
 * theme doesn't know about local data-theme overrides.
 */
export default function BrandLogo({
  className,
  style,
  alt = "BusinessLocating",
  draggable,
  variant = "auto",
}: {
  className?: string;
  style?: CSSProperties;
  alt?: string;
  draggable?: boolean;
  /** Force a specific logo instead of following the global theme. */
  variant?: "auto" | "dark" | "light";
}) {
  const theme = useTheme();
  const effective = variant === "auto" ? theme : variant;
  return (
    <img
      src={effective === "light" ? lightLogo : darkLogo}
      alt={alt}
      className={className}
      style={style}
      draggable={draggable}
    />
  );
}
